import { motion } from 'framer-motion';

export function MaskedLines({ lines, delay = 0.1, as: Tag = 'div', className = '' }) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag className={className} initial="hidden" animate="show">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${line.cls || ''}`}
            variants={{
              hidden: { y: '110%' },
              show: { y: '0%', transition: { duration: 0.9, delay: delay + i * 0.14, ease: [0.16, 1, 0.3, 1] } },
            }}
          >
            {line.text}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

export function FadeUp({ children, delay = 0, className = '', y = 36, ...rest }) {
  return (
    <motion.div
      className={className}
      {...rest}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <span className={`eyebrow ${dark ? 'text-gold-dim' : ''}`}>
      <span className="inline-block h-2 w-2 bg-gold" />
      {children}
    </span>
  );
}

export function Chapter({ n, label, dark = false }) {
  return (
    <FadeUp className="mb-10 flex items-baseline gap-4">
      <span className="chapter text-2xl md:text-3xl">{String(n).padStart(2, '0')}</span>
      <Eyebrow dark={dark}>{label}</Eyebrow>
      <span className={`h-px flex-1 ${dark ? 'bg-black/10' : 'bg-white/10'}`} />
    </FadeUp>
  );
}
